// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_jlpt_levels_n4_description = /** @type {(inputs: {}) => string} */ () => {
	return `Build your foundation! Improve your grammar, expand your vocabulary, and start forming more natural sentences.`
};

const id_jlpt_levels_n4_description = /** @type {(inputs: {}) => string} */ () => {
	return `Bangun fondasi Anda! Perbaiki tata bahasa Anda, perluas kosakata Anda, dan mulailah membentuk kalimat yang lebih alami.`
};

const ja_jlpt_levels_n4_description = /** @type {(inputs: {}) => string} */ () => {
	return `基礎を固めましょう！文法を強化し、語彙を増やし、より自然な文章を作り始めましょう。`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const jlpt_levels_n4_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jlpt_levels_n4_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("jlpt_levels_n4_description", locale)
	if (locale === "en") return en_jlpt_levels_n4_description(inputs)
	if (locale === "id") return id_jlpt_levels_n4_description(inputs)
	return ja_jlpt_levels_n4_description(inputs)
};
export { jlpt_levels_n4_description as "jlpt_levels.n4.description" }